export default __webpack_public_path__ + "static/media/Stalker's Wristbands of Waning Dusk.d981d197.jpg";